<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 2em;">
      <img src="@/img/hensel-loading.svg" alt="loading">
    </div>
    <form v-else class="search" @submit="search" @reset="resetFilter" style="max-height: calc(100vh - 100px)">
      <div id="search_container"
           class="container medium-text" style="max-height: calc(100vh - 100px)">
        <div class="row">
          <div class="col-xs-12">
            <div class="row bg-blue">
              <div class="col-xs-12">
                <input type="text"
                       id="searchbox"
                       :placeholder="_('Volltextsuche')"
                       autocorrect="off"
                       autocomplete="off"
                       autocapitalize="off"
                       spellcheck="false"
                       v-model="filter.query"
                       @input="fetchSuggestionList"
                >
                <suggestion-list :options="inscriptions" @change="continueWithSuggestion"/>
              </div>
            </div>
            <div class="row bg-light-blue ">
              <div class="col-xs-12 spacer-top spacer-bottom">
                {{ _('Erweiterte Suche') }}
              </div>
            </div>
          </div>
        </div>

        <div class="search-parameter-wrap row bg-white color-light" style="flex-grow: 1">
          <div class="col-xs-12 " v-if="businessCases.length > 1">
            <label for="search_businessCase">{{ _('Produkttyp') }}</label>
            <select
                id="search_businessCase"
                v-model="filter.business_case"
                name="businessCase"
                class="color-blue"
                @change="onBusinessCaseChange"
            >
              <option value="">{{ _('Alle') }}</option>
              <option v-for="businessCase in businessCases"
                      :value="businessCase.id"
                      :key="'businessCase_' + businessCase.id"
              >{{ translateBusinessCase(businessCase) }}
              </option>
            </select>
          </div>
          <div class="col-xs-12 ">
            <label for="search_brand" v-if="isConverter">{{ _('Hersteller') }}</label>
            <label for="search_brand" v-else-if="isEscrap">{{ _('Materialgruppe') }}</label>
            <label for="search_brand" v-else>{{ _('Hersteller/Materialgruppe') }}</label>
            <select id="search_brand" v-model="filter.brand" name="brand" class="color-blue">
              <option value="">{{ _('Alle') }}</option>
              <option v-for="brand in sortedBrands" :value="brand.id" :key="'brand_' + brand.id">
                {{ translateBrand(brand) }}
              </option>
            </select>
          </div>
          <div class="col-xs-12">
            <label for="search_material">{{ _('Material') }}</label>
            <select id="search_material" v-model="filter.material" name="material" class="color-blue">
              <option value="">{{ _('Alle') }}</option>
              <option v-for="material in sortedMaterials"
                      :value="material.id" :key="'material_' + material.id">
                {{ translateMaterial(material) }}
              </option>
            </select>
          </div>
          <div class="col-xs-12" v-if="isConverterSelected">
            <label for="search_engines">{{ _('Kraftstoff') }}</label>
            <select id="search_engines" v-model="filter.engine" name="engine" class="color-blue">
              <option value="">{{ _('Alle') }}</option>
              <option v-for="engine in sortedEngines"
                      :value="engine.id" :key="'engine_' + engine.id">
                {{ translateEngine(engine) }}
              </option>
            </select>
          </div>
          <div class="col-xs-12">
            <label for="search_region">{{ _('Region') }}</label>
            <select id="search_region" v-model="filter.region" name="region" class="color-blue">
              <option value="">{{ _('Alle') }}</option>
              <option v-for="region in sortedRegions"
                      :value="region.id" :key="'region_' + region.id">
                {{ translateRegion(region) }}
              </option>
            </select>
          </div>
          <div class="col-xs-12" v-if="isConverterSelected">
            <label for="search_length">{{ _('Länge 0-100 cm') }}</label>
            <select @change="setLengthFilter" id="search_length" class="color-blue">
              <option value="">{{ _('Alle') }}</option>
              <option v-for="i in 100" :value="i">{{ i }} cm</option>
            </select>
          </div>
        </div>
        <div class="row spacer-bottom">
          <div class="col-xs-12">
            <button type="reset"
                    class="bg-blue color-white"
                    style="border: 1px solid;"
                    v-html="_('ZURÜCKSETZEN')"></button>
          </div>
          <div class="col-xs-12">
            <button type="submit" class="bg-light-blue search-button"
                    v-html="_('Suchen')"></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
//Vuex
import Vue from 'vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

//Mixins
import forwardEvents from '../mixins/forwardEvents.js'
//Components
import Modal from '../components/Modal'
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
import CombinedImage from '../components/CombinedImage'
import PinchZoomOverlay from '../components/PinchZoomOverlay'
import { createQueryString } from '@/store/modules/Api'
import SuggestionList from '@/components/SuggestionList'

export default {
  name: 'Search',
  mixins: [forwardEvents],
  components: { SuggestionList, PinchZoomOverlay, CombinedImage, BulmaAccordion, BulmaAccordionItem, Modal },
  data () {
    return {
      filter: {
        query: '',
        brand: '',
        material: '',
        engine: '',
        region: '',
        minLength: '',
        maxLength: '',
        business_case: '',
      },
      inscriptions: [],
      zoomedImage: '',
      loading: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.Api.Users.current,
      attributes: state => state.Api.Converters.attributes,
      _lang: state => state.Api.Localizations.language,
    }),
    ...mapGetters({
      getAuthHeader: 'Api/getAuthHeader',
    }),
    isConverterSelected () {
      return this.onlyConverters || [1, 3].includes(this.filter.business_case)
    },
    onlyConverters () {
      return this.businessCases.length === 1 && [1, 3].includes(this.businessCases[0].id)
    },
    isConverter () {
      return this.onlyConverters || [1, 3].includes(this.filter.business_case)
    },
    onlyEscrap () {
      return this.businessCases.length === 1 && [2, 4].includes(this.businessCases[0].id)
    },
    isEscrap () {
      return this.onlyEscrap || [2, 4].includes(this.filter.business_case)
    },
    minQueryLength () {
      if (this.isEscrap) {
        return 2
      } else {
        return 3
      }
    },
    businessCases () {
      return this.attributes?.business_cases ?? []
    },
    filteredBrands () {
      if (!this.filter.business_case) {
        return this.attributes?.brands ?? []
      } else {
        return (this.attributes?.brands ?? [])
            .filter(brand => brand.business_case_id === this.filter.business_case)
      }
    },
    sortedBrands () {
      return this.sortBy(this.filteredBrands,
          brand => this.translateBrand(brand).toLocaleLowerCase())
    },
    filteredMaterials () {
      if (!this.filter.business_case) {
        return this.attributes?.materials ?? []
      } else {
        return (this.attributes?.materials ?? [])
            .filter(material => material.business_case_id === this.filter.business_case)
      }
    },
    sortedMaterials () {
      return this.sortBy(this.filteredMaterials,
          material => this.translateMaterial(material).toLocaleLowerCase())
    },
    filteredEngines () {
      return this.attributes?.engines ?? []
    },
    sortedEngines () {
      return this.sortBy(this.filteredEngines,
          engine => this.translateEngine(engine).toLocaleLowerCase())
    },
    filteredRegions () {
      if (!this.filter.business_case) {
        return this.attributes?.regions ?? []
      } else {
        return (this.attributes?.regions ?? [])
            .filter(region => region.business_case_id === this.filter.business_case)
      }
    },
    sortedRegions () {
      return this.sortBy(this.filteredRegions,
          region => this.translateRegion(region).toLocaleLowerCase())
    },
  },
  methods: {
    ...mapActions({
      fetchConverters: 'Api/Converters/all',
      apiRequest: 'Api/apiRequest',
      refreshAttributes: 'Api/Converters/attributes',
    }),
    ...mapMutations({
      updateFilter: 'setFilter',
      setScrollY: 'setCatalogueScrollY',
      clearConverters: 'Api/Converters/reset',
      addConverter: 'Api/Converters/add',
    }),
    onBusinessCaseChange () {
      this.$set(this.filter, 'brand', '')
      this.$set(this.filter, 'material', '')
      this.$set(this.filter, 'engine', '')
      this.$set(this.filter, 'minLength', '')
      this.$set(this.filter, 'maxLength', '')
    },
    setLengthFilter (e) {
      const len = parseFloat(e.target.value)
      const tolerance = len * 0.05 // tolerance 5%

      const minLen = Math.floor(len - tolerance)
      const maxLen = Math.ceil(len + tolerance)

      Vue.set(this.filter, 'maxLength', maxLen.toString())
      Vue.set(this.filter, 'minLength', minLen.toString())
    },
    fetchSuggestionList () {
      if (this.suggestionListTimeout) {
        clearTimeout(this.suggestionListTimeout)
      }

      if (this.filter.query.length < this.minQueryLength) {
        Vue.set(this.$data, 'inscriptions', [])
        return
      }

      this.suggestionListTimeout = setTimeout(async () => {
        const headers = {
          'Content-Type': 'application/json',
          ...this.getAuthHeader,
        }

        let actionPath = '/api/converters/all.json'
        const query = createQueryString({
          filter: { number: this.filter.query },
          limit: { offset: 0, length: Number.MAX_SAFE_INTEGER },
          language: this._lang,
        })

        if (query) {
          actionPath = [actionPath, query].join('?')
        }

        try {
          this.inscriptions = (await this.apiRequest({
            actionPath: actionPath,
            method: 'get',
            headers: headers,
          }))
              .map(product => {
                if ([1, 3].includes(product.region.business_case_id)) {
                  return product.inscriptions
                      .flat()
                      .filter(i => i?.identifying)
                      .map(i => this.translateInscription(i))
                } else {
                  return [this.translateConverter(product)]
                }
              })
              .flat()
              .filter((i, idx, array) => array.findIndex(el => el === i) === idx)
        } catch (e) {
          this.apiErrorHandler(e)
        }
      }, 250)
    },
    continueWithSuggestion (suggestion) {
      Vue.set(this.filter, 'query', suggestion)
      this.search()
    },
    async search (e) {
      if (e) {
        e.preventDefault()
      }

      this.loading = true

      try {
        const result = await this.fetchConverters({
          filter: this.filter,
          limit: { offset: 0, length: 6 },
          language: this._lang,
        })

        if (window.Piwik) {
          const trackers = window.Piwik.getAsyncTrackers()
          trackers.forEach(el => el.trackSiteSearch(JSON.stringify({
            query: this.filter.query,
            brand: this.filter.brand,
            material: this.filter.material,
            region: this.filter.region,
            lowerBound: this.filter.minLength,
            upperBound: this.filter.maxLength,
          }), 'KATalog', result.length))
        }

        if (result.length === 0) {
          this.$store.commit('setLatestError', {
            code: 204,
            message: this._('Keine Treffer gefunden.'),
          })
        }

        this.clearConverters()
        result.forEach(item => this.addConverter({ item }))

        this.setScrollY(0)

        this.$router.push('/home', () => null, () => null)
      } catch (err) {
        this.apiErrorHandler(err)
      } finally {
        this.loading = false
      }
    },
    resetFilter () {
      Vue.set(this, 'filter', {
        query: '',
        brand: '',
        material: '',
        engine: '',
        region: '',
        minLength: '',
        maxLength: '',
        business_case: '',
      })
    },
    /**
     * @param {array} array
     * @param {string|function} sortByKey
     * @return {*}
     */
    sortBy (array, sortByKey = 'name') {
      let valueTransformer = sortByKey

      if (typeof valueTransformer !== 'function') {
        valueTransformer = entity => entity[sortByKey].toLocaleLowerCase()
      }

      return array.sort((a, b) => {
        const nameA = valueTransformer(a)
        const nameB = valueTransformer(b)

        return nameA.localeCompare(nameB)
      })
    },
  },
  mounted () {
    if (!this.user) {
      this.$router.push({ name: 'Login' })
      return
    }

    Vue.set(this, 'filter', this.$store.state.filter)

    this.refreshAttributes()
        .catch(this.apiErrorHandler)
  },
  updated () {
    this.updateFilter(this.filter)
  },
}
</script>
